/**
 * 排序
 */
export const SORT = {
  // 降序
  DESC: 0,
  // 升序
  ASC: 1,
  // 随机排序
  RANDOM: 2,
};
